export const publicMessages = {
  de: {
    footer: {
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      agb: 'AGB'
    },
    pages: {
      login: {
        title: 'Willkommen zurück',
        brandHint: 'Dein mentalLoad-Dashboard für den Familienalltag',
        subtitle: 'Melde dich an, um Aufgaben, Termine und Verantwortlichkeiten gemeinsam zu organisieren.',
        email: 'E-Mail',
        password: 'Passwort',
        submit: 'Einloggen',
        idleLogout: 'Du wurdest wegen Inaktivität ausgeloggt.',
        expiredSession: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
        noAccount: 'Noch kein Konto?',
        register: 'Registrieren',
        resendVerification: 'Bestätigungs-Mail erneut senden',
        restoringSession: 'Sitzung wird geprüft …',
        verifiedSuccess: 'Deine E-Mail wurde bestätigt. Du kannst dich jetzt einloggen.'
      },
      register: {
        title: 'Registrieren',
        subtitle: 'Starte deine kostenlose Testphase und richte dein mentalLoad-Konto ein.',
        badge: 'Kostenlos testen',
        hint: 'Erstelle dein Konto und bestätige danach deine E-Mail-Adresse.',
        name: 'Name',
        nameOptional: 'Vorname (optional)',
        email: 'E-Mail',
        password: 'Passwort',
        language: 'Sprache',
        languageDe: 'Deutsch',
        languageEn: 'Englisch',
        terms: 'Ich stimme den AGB und der Datenschutzerklärung zu.',
        submit: 'Konto erstellen',
        loginHint: 'Schon registriert?',
        loginLink: 'Zum Login'
      },
      verify: {
        title: 'E-Mail bestätigen',
        loading: 'Wir prüfen deinen Link …',
        success: 'E-Mail bestätigt. Du kannst dich jetzt einloggen.',
        error: 'Der Link konnte nicht bestätigt werden.',
        missingToken: 'Der Verifizierungslink ist unvollständig.',
        loginLink: 'Zum Login'
      }
    }
  },
  en: {
    footer: {
      impressum: 'Imprint',
      datenschutz: 'Privacy',
      agb: 'Terms'
    },
    pages: {
      login: {
        title: 'Login',
        brandHint: 'Your family dashboard from mentallast.de',
        subtitle: 'Sign in to organize tasks, appointments, and responsibilities.',
        email: 'Email',
        password: 'Password',
        submit: 'Sign in',
        idleLogout: 'You have been logged out due to inactivity.',
        expiredSession: 'Your session has expired. Please sign in again.',
        noAccount: "Don't have an account yet?",
        register: 'Register',
        resendVerification: 'Resend verification email',
        restoringSession: 'Checking your session …',
        verifiedSuccess: 'Your email has been verified. You can sign in now.'
      },
      register: {
        title: 'Registrieren',
        subtitle: 'Starte deine kostenlose Testphase und richte dein mentalLoad-Konto ein.',
        badge: 'Kostenlos testen',
        hint: 'Erstelle dein Konto und bestätige danach deine E-Mail-Adresse.',
        name: 'Name',
        nameOptional: 'Vorname (optional)',
        email: 'E-Mail',
        password: 'Passwort',
        language: 'Sprache',
        languageDe: 'Deutsch',
        languageEn: 'Englisch',
        terms: 'Ich stimme den AGB und der Datenschutzerklärung zu.',
        submit: 'Konto erstellen',
        loginHint: 'Schon registriert?',
        loginLink: 'Zum Login'
      },
      verify: {
        title: 'Verify email',
        loading: 'Checking your link …',
        success: 'Email verified. You can sign in now.',
        error: 'The link could not be verified.',
        missingToken: 'The verification link is incomplete.',
        loginLink: 'Go to login'
      }
    }
  }
};
